export const faqData = [
  {
    category: 'About Escape Plan',
    faq: [
      {
        title: 'What is Escape Plan?',
        content:
          "Escapeplan is a premier provider of blueprint services, specializing in delivering precise and compliant CAD files and PDF escape plans tailored to your building's unique specifications. Led by our skilled team of AutoCAD technicians, we meticulously convert building drawings into professional blueprints, ensuring accuracy and compliance with regulatory standards. With a focus on efficiency and precision, we streamline the process to provide prompt delivery without compromising on quality. ",
      },
      {
        title: 'What services does Escape Plan offer?',
        content: 'Answer to the second question.',
      },
      {
        title: 'How does Escape Plan work?',
        content: 'Answer to the third question.',
      },
    ],
  },
  {
    category: 'Using Escape Plan',
    faq: [
      {
        title: ' How can I upload my building drawings to Escape Plan?',
        content: 'Answer to the third question.',
      },
      {
        title:
          "Can I customize the escape plans to my building's specifications",
        content: 'Answer to the fourth question.',
      },
      {
        title: 'How long does it take to receive the completed escape plans?',
        content: 'Answer to the fourth question.',
      },
      {
        title: 'How can I track the progress of my project on Escape Plan?',
        content: 'Answer to the fourth question.',
      },
      {
        title: 'Can I cancel or modify my project after it has been submitted?',
        content: 'Answer to the fourth question.',
      },
    ],
  },
  {
    category: 'Materials and payments',
    faq: [
      {
        title: 'What materials are used for printing the escape plans?',
        content: 'Answer to the third question.',
      },
      {
        title: 'What payment methods are accepted on Escape Plan?',
        content: 'Answer to the fourth question.',
      },
      {
        title: 'Are there any additional fees or charges I should be aware of?',
        content: 'Answer to the fourth question.',
      },
    ],
  },
  {
    category: 'Support and Security',
    faq: [
      {
        title:
          'Is there a customer support team available to assist with any issues?',
        content: 'Answer to the third question.',
      },
      {
        title:
          'Is my personal information and project data secure on Escape Plan?',
        content: 'Answer to the fourth question.',
      },
    ],
  },
  {
    category: 'Feedback and Discounts',
    faq: [
      {
        title:
          ' Can I provide feedback or review the service after completion?',
        content: 'Answer to the third question.',
      },
      {
        title:
          'Are there any discounts or promotions available for recurring projects?',
        content: 'Answer to the fourth question.',
      },
    ],
  },
];
